import React, { FC } from 'react';
import { Box, Table, Text } from '@chakra-ui/react';

interface Row {
  label: string;
  lite: string;
  plus: string;
  enterprise: string;
}

const ROWS: Row[] = [
  { label: 'Documents / month', lite: '100', plus: '1,000', enterprise: 'Unlimited' },
  { label: 'Storage included', lite: '1 GB', plus: '2 GB', enterprise: 'Unlimited' },
  { label: 'Unlimited users', lite: '✓', plus: '✓', enterprise: '✓' },
  { label: 'Legal compliance archiving', lite: '✓', plus: '✓', enterprise: '✓' },
  { label: 'CSV upload + mapping tool', lite: '✓', plus: '✓', enterprise: '✓' },
  { label: 'Manual invoice / credit note', lite: '✓', plus: '✓', enterprise: '✓' },
  { label: 'Automated daily reports', lite: '—', plus: '✓', enterprise: '✓' },
  { label: 'API access', lite: '—', plus: '✓', enterprise: '✓' },
  { label: 'AI error handling', lite: '—', plus: '✓', enterprise: '✓' },
  { label: 'Real-time translation', lite: '—', plus: '—', enterprise: '✓' },
  { label: 'Access to tax experts', lite: '—', plus: '—', enterprise: '✓' },
  { label: 'SSO', lite: '—', plus: '—', enterprise: '✓' },
  { label: 'Multi-entity management', lite: '—', plus: '—', enterprise: '✓' }
];

const PricingTable: FC = () => (
  <Box overflowX='auto'>
    <Table.Root size='sm' striped>
      <Table.Header>
        <Table.Row>
          <Table.ColumnHeader>Feature</Table.ColumnHeader>
          <Table.ColumnHeader textAlign='center'>Lite</Table.ColumnHeader>
          <Table.ColumnHeader textAlign='center'>Plus</Table.ColumnHeader>
          <Table.ColumnHeader textAlign='center'>Enterprise</Table.ColumnHeader>
        </Table.Row>
      </Table.Header>
      <Table.Body>
        {ROWS.map((r) => (
          <Table.Row key={r.label}>
            <Table.Cell>
              <Text>{r.label}</Text>
            </Table.Cell>
            <Table.Cell textAlign='center'>{r.lite}</Table.Cell>
            <Table.Cell textAlign='center'>{r.plus}</Table.Cell>
            <Table.Cell textAlign='center'>{r.enterprise}</Table.Cell>
          </Table.Row>
        ))}
      </Table.Body>
    </Table.Root>
  </Box>
);

export default PricingTable;
